// extracted by mini-css-extract-plugin
module.exports = {"label":"sharedStyles_label__1ClnV","link":"sharedStyles_link__2S6WR","icon":"sharedStyles_icon__Ucdxs"};